/* @flow */
import AuthActions from 'auth/AuthActions';
import BoxBody from 'components/BoxBody.jsx';
import Device from 'entities/Device';
import DialogContent from 'components/DialogContent.jsx';
import enumerate from 'lib/enumerate';
import JoinEmailAccountUpgradeForm from './JoinEmailAccountUpgradeForm.jsx';
import JoinPageLoadingIndicator from './JoinPageLoadingIndicator.jsx';
import React from 'react';

const STATUS = enumerate([
  'confirming',
  'form',
]);

const JoinConfirmEmailDevicePage = React.createClass({
  propTypes: {
    location: React.PropTypes.object.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    const query = this.props.location.query;

    return {
      token: query['token'],
      verificationToken: query['verification_token'],
      status: STATUS.confirming,
      error: '',
    };
  },

  componentDidMount() {
    const onSessionExchangeError = () => {
      this.setState({
        error: 'Link might have expired.',
      });
    };

    const confirmEmailDevice = (user) => {
      const onSuccess = () => {
        if (user.hasPassword()) {
          this.context.router.push(`/join/${this.props.params.groupCode}`);
        } else {
          this.setState({ status: STATUS.form });
        }
      };

      const onError = () => {
        this.setState({ error: 'Cannot confirm email.' });
      };

      Device
        .confirmEmailDevice(this.state.verificationToken)
        .then(onSuccess, onError);
    };

    AuthActions
      .accessTokenSignIn(this.state.token)
      .then(confirmEmailDevice, onSessionExchangeError);
  },

  redirectToInfoPage() {
    const groupCode = this.props.params.groupCode;
    this.context.router.push(`/information_required/${groupCode}`);
  },

  renderAccountForm() {
    return <JoinEmailAccountUpgradeForm onDone={this.redirectToInfoPage} />;
  },

  renderConfirming() {
    if (this.state.error) {
      return (
        <DialogContent
          size="small"
          title={'An error occured'}
          subtext={this.state.text}>
          <BoxBody divided>
            {this.state.error}
          </BoxBody>
        </DialogContent>
      );
    }

    return (
      <JoinPageLoadingIndicator />
    );
  },

  render() {
    return {
      [STATUS.confirming]: this.renderConfirming,
      [STATUS.form]: this.renderAccountForm,
    }[this.state.status]();
  },
});

export default JoinConfirmEmailDevicePage;



// WEBPACK FOOTER //
// ./src/join/components/JoinConfirmEmailDevicePage.jsx